<template>
  <div>
    <a-row class="mb-10">
      <a-table
        class="tableDataTabs"
        bordered
        :pagination="tableData.pagination"
        :columns="tableData.columns"
        :rowKey="record => record.id"
        :dataSource="tableData.data"
        :loading="tableData.loading"
        @change="handleTableChange"
      >
        <template slot="actions" slot-scope="text, record">
          <a href="javascript:;" @click="() => showDetail(record)">详情</a>
        </template>
      </a-table>
    </a-row>

  </div>
</template>

<script>
// import { xxx } from '@/api/xxx'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (val) {
        console.log('触发', val)
        this.clear()
        this.initData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      tableData: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            width: 50
          },
          {
            title: '任务编号',
            dataIndex: 'xxx1',
            align: 'left'
          },
          {
            title: '任务名称',
            dataIndex: 'xxx2',
            align: 'left'
          },
          {
            title: '任务类型',
            dataIndex: 'xxx3',
            align: 'left'
          },
          {
            title: '任务状态',
            dataIndex: 'xxx4',
            align: 'left'
          },
          {
            title: '创建人',
            dataIndex: 'xxx5',
            align: 'left'
          },
          {
            title: '维修人',
            dataIndex: 'xxx6',
            align: 'left'
          },
          {
            title: '计划开始时间',
            dataIndex: 'xxx7',
            align: 'left'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'left'
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          showQuickJumper: true
        },
        loading: false
      }
    }
  },
  methods: {
    async initData () {
      this.tableData.loading = true
      for (let i = 0; i < 99; i++) {
        this.tableData.data.push({
          id: i,
          xxx1: 'xxx' + i,
          xxx2: 'xxx' + i,
          xxx3: 'xxx' + i,
          xxx4: 'xxx' + i,
          xxx5: 'xxx' + i,
          xxx6: 'xxx' + i,
          xxx7: 'xxx' + i
        })
      }
      // const { current, pageSize } = this.tableData.pagination
      // const params = { pageNum: current, pageSize }
      // const res = await xxxx(params)
      // if (res && res.status === 0) {
      //   this.tableData.data = res.data.list
      //   this.tableData.pagination.total = res.data.total
      // } else {
      //   this.$message.error(res.info.message)
      // }
      this.tableData.loading = false
    },
    handleTableChange (pagination) {
      this.tableData.pagination.pageSize = pagination.pageSize
      this.tableData.pagination.current = pagination.current
      this.initData()
    },
    clear () {
      this.tableData.data = []
      this.tableData.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      }
    },
    showDetail () {}
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-thead{
  height: 32px;
  & th{
    background: #E6ECF5;
  }
}
.table /deep/ .ant-table-body {
  border-left: 1px solid #DDDDDD;
}
.tableDataTabs /deep/ .ant-table-body {
  border-left: 1px solid #DDDDDD;
}
.mb-10{
  margin-bottom: 10px;
}
</style>
